import Link from "next/link";
import styles from "./index.module.scss";

const HelpBtn = ({
  href,
  extraClass,
}: {
  href: string;
  extraClass?: string;
}) => (
  <Link href={href} passHref>
    <a
      target="_blank"
      rel="noopener noreferrer"
      className={styles.button + " " + extraClass}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9 19.3456H13.1V17.1456H10.9V19.3456ZM12 1.74561C5.928 1.74561 1 6.67361 1 12.7456C1 18.8176 5.928 23.7456 12 23.7456C18.072 23.7456 23 18.8176 23 12.7456C23 6.67361 18.072 1.74561 12 1.74561ZM12 21.5456C7.149 21.5456 3.2 17.5966 3.2 12.7456C3.2 7.89461 7.149 3.94561 12 3.94561C16.851 3.94561 20.8 7.89461 20.8 12.7456C20.8 17.5966 16.851 21.5456 12 21.5456ZM12 6.14561C9.569 6.14561 7.6 8.11461 7.6 10.5456H9.8C9.8 9.33561 10.79 8.34561 12 8.34561C13.21 8.34561 14.2 9.33561 14.2 10.5456C14.2 12.7456 10.9 12.4706 10.9 16.0456H13.1C13.1 13.5706 16.4 13.2956 16.4 10.5456C16.4 8.11461 14.431 6.14561 12 6.14561Z"
          fill="white"
        />
      </svg>
    </a>
  </Link>
);

export default HelpBtn;
